/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

const bundleHandle = 'doctor-proctors-best-sellers-bundle-5-x-100g';

function fixBundleShippingMessage() {
  const hasBundle = document.querySelector(
    `[data-cart-item][data-product-handle="${bundleHandle}"]`
  );

  if (!hasBundle) return;

  document.querySelectorAll('[data-cart-message]').forEach((message) => {
    const defaultMessage = message.querySelector('[data-message-default]');
    const successMessage = message.querySelector('.cart-message__success');
    const progressItems = message.querySelectorAll('[data-cart-message-progress]');

    message.classList.add('is-success');

    if (defaultMessage) {
      defaultMessage.classList.add('is-hidden');
    }

    if (successMessage) {
      successMessage.classList.remove('is-hidden');
    }

    progressItems.forEach((progress) => {
      progress.classList.add('is-hidden');
    });
  });
}

document.addEventListener('DOMContentLoaded', fixBundleShippingMessage);

const observer = new MutationObserver(() => {
  fixBundleShippingMessage();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
